import { Transforms } from "slate";
import { getSelection } from "../selectors";
function wrapInline(editor, inline) {
  Transforms.wrapNodes(editor, inline, {
    at: getSelection(editor),
    split: true
  });
}
export {
  wrapInline
};
//# sourceMappingURL=wrapInline.js.map